/**
 * Recado de uma tela para a próxima quando a volta é feita pelo histórico (que não leva `state`).
 * Quem recebe lê com `lerAviso()` ao abrir e limpa com `limparAviso()` depois de montar.
 */
let pendente: string | null = null;

export function guardarAviso(mensagem: string) {
  pendente = mensagem;
}

export function lerAviso(): string | null {
  return pendente;
}

export function limparAviso() {
  pendente = null;
}
